import styles from './button.module.scss';



export const Button = ({children, onClick}) => {
  return <button className={styles.button} onClick={onClick}> {children} </button>
}